export enum ApiKeys {
  UserCurrentPendingOrders = 'api/user/current/orders/pending',
  UserCurrentOrders = 'api/user/current/orders',
}

export const LOCALE = 'en-GB'
